import React from 'react'
import Navbar from '../commonComponents/Navbar'
import Footer from '../commonComponents/Footer'
import ServicesHero from '../commonComponents/ServicesHero'
import SectionHeader from '../commonComponents/SectionHeader'
import { Box, Container, Grid } from '@mui/material'
import ServiceCard from '../commonComponents/ServiceBusinessCard'
import servicesBus from '../../assets/images/services_bus.png'
import servicesOtc from '../../assets/images/services_otc.png'
import SmallCard from '../commonComponents/SmallCard'
import useScrollAnimation from '../../hooks/useScrollAnimation'

import servicesHeroImg from "../../assets/images/services_banner.png";
import exchangeIcon from "../../assets/images/Exchange_icon.png";
import bussinessIcon from "../../assets/images/Bussiness_icon.png";

import daimondIcon from "../../assets/images/daimond_icon.png";
import buildingIcon from "../../assets/images/build_icon.png";
import employeeIcon from "../../assets/images/employee_icon.png";


const Services = () => {
    const [sectionHeaderRef, sectionHeaderVisible] = useScrollAnimation(0.2);
    const [cardsRef, cardsVisible] = useScrollAnimation(0.1);

    return (
        <div className="page-enter">
            <Navbar />
            <ServicesHero
                heading="Our Services"
                highlightedText=""
                description="Payible delivers secure and reliable digital asset solutions, enabling direct crypto purchases, instant settlement for traders, investors, individuals and businesses."
                subDescription=""
                image={servicesHeroImg}
            />

            <Container maxWidth="lg" sx={{ mt: { xs: 10, md: 14 }, mb: { xs: 10, md: 14 } }}>
                <Box
                    ref={sectionHeaderRef}
                    className={`anim-fade-up${sectionHeaderVisible ? ' in-view' : ''}`}
                >
                    <SectionHeader
                        title="Powering Individuals and Businesses."
                        description="An overview of the digital asset solutions available through Payible."
                        titleClassName="asset-title"
                        descriptionClassName="asset-desc"
                        titleSx={{
                            fontSize: {
                                xs: "2rem",
                                sm: "2.5rem",
                                md: "2.2rem",
                            },
                            fontWeight: 700,
                        }}
                        descriptionSx={{
                            color: "rgba(255,255,255,0.7)",
                            mt: 1,
                        }}
                    />
                </Box>

                <Grid
                    container
                    spacing={4}
                    ref={cardsRef}
                    sx={{
                        mt: { xs: 2, md: 4 },
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {[
                        {
                            title: "For Individuals & Traders",
                            description: "Access direct fiat-to-crypto conversion with instant settlement and dedicated customer support whenever you trade.",
                            icon: <Box
                                component="img"
                                src={employeeIcon}
                                alt="Logo"
                                sx={{
                                    width: 70,
                                    height: '300',
                                }}
                            />,
                        },
                        {
                            title: "For Businesses",
                            description: "Accept and process crypto payments seamlessly while maintaining full security and built-in compliance.",
                            icon: <Box
                                component="img"
                                src={buildingIcon}
                                alt="Logo"
                                sx={{
                                    width: 70,
                                    height: 'auto',
                                }}
                            />,
                        },
                        {
                            title: "For High Net Worth",
                            description: "Execute high-value digital asset transactions with dedicated support, enhanced security, competitive pricing, and fast, reliable settlement.",
                            icon: <Box
                                component="img"
                                src={daimondIcon}
                                alt="Logo"
                                sx={{
                                    width: 70,
                                    height: '300',
                                }}
                            />,
                        },
                    ].map((card, index) => (
                        <Grid
                            key={index}
                            size={{ xs: 12, md: 4 }}
                            className={`anim-fade-up anim-d${index}${cardsVisible ? ' in-view' : ''}`}
                            sx={{
                                display: "flex",
                                boxShadow: "var(--fs-card-background-shadow)",
                                // Remove the conditional minHeight from here
                            }}
                        >
                            <SmallCard
                                icon={card.icon}
                                title={card.title}
                                description={card.description}
                                // Apply height logic here instead
                                sx={{
                                    ...(index === 1 ? {
                                        minHeight: { xs: 380, md: 370 }
                                    } : {
                                        minHeight: { xs: 300, md: 325 }
                                    })
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 10, md: 16 },
                        my: { xs: 10, md: 16 },
                    }}
                >
                    <ServiceCard
                        image={servicesOtc}
                        badgeText="Retail & OTC Exchange"
                        badgeIcon={
                            <Box
                                sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: "50%",
                                    background: "#87E0CC",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={exchangeIcon}
                                    alt="icon"
                                    sx={{
                                        width: "30px",
                                        height: "30px",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                        }
                        title="Trade With Confidence. Deep Liquidity for Every Trader."
                        description1="Payible provides secure, non-custodial OTC crypto exchange services designed for speed and simplicity. Built for both retail traders and high-volume institutional clients, Payible offers a seamless exchange experience with dedicated support and streamlined payment rails."
                        description2="Clients can execute large trades through a dedicated account manager, access deep digital asset liquidity, and move from fiat to crypto in minutes through supported payment rails."
                    />
                </Box>

            </Container>
            <Footer />
        </div>
    )
}

export default Services
